// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card_g1f8F","image":"Card_image_fCVb7","title":"Card_title_1sRV4"};